export default __webpack_public_path__ + "e3c60a10680b19a7638777933e63ee62.png";